// extracted by mini-css-extract-plugin
export default {"root":"wpH8qkLhhBNwHzwdcje0","title":"OL9QhO5ecosFLS9czAW_","left":"j9wvI5EaKb7H7ZOB18aq","right":"ilE1YHaNjtyVEp9l6dva","text-margin-resend":"BIBLh92Vh2U8b9ayVMX0"};